import React from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";
import {format} from 'date-fns';

const AccountInformation = (props) => {
    const credentialType = props.credentialType
    const formDisabled = props.formDisabled

    let formatDate = () => {
        let date = '' 

        if(credentialType && credentialType.date)
            date = format(credentialType.date, "yyyy-MM-dd")
        
        return date
    }

    return (
        <>
            <hr className="my-4" />

            <h6 className="heading-small text-muted mb-4">Account Information</h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-creation"
                            >
                                Creation Date
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-creation"
                                defaultValue={formatDate()}
                                type="date"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                    
                </Row>
            </div>
        </>
    )
}

export default AccountInformation